// Shared public identity is also consumed by the plain-Node SEO generators.
import identity from './site-identity.json';
import lifecycle from './oracle-lifecycle.json';

export const SITE_ORIGIN = identity.origin;
export const SITE_NAME = identity.name;
export const SITE_TAGLINE = identity.tagline;
export const SITE_DESCRIPTION = identity.description;
export const EMAIL = identity.contact.email;
// Add a confirmed business number in site-identity.json when available.
export const PHONE = identity.contact.phone;
export const PHONE_E164 = identity.contact.phoneE164;
// Google Calendar appointment schedule (BV Workspace), shared by the brand sites.
export const BOOKING_URL = 'https://calendar.app.google/4uH6U12c7BtVSJJ69';
export const OG_IMAGE_PATH = '/og-image.png?v=1';

// Shared lead engine (one endpoint serves every brand site; this site posts
// `brand: "ecmworks"`). VITE_LEAD_ENGINE_URL overrides it at build time.
export const LEAD_ENGINE_URL =
  import.meta.env.VITE_LEAD_ENGINE_URL ||
  'https://quuipwhosgbsbzzgiafh.supabase.co/functions/v1/submit-lead';

// Enable only after the backend supports this header and durable receipt keys.
export const LEAD_IDEMPOTENCY_ENABLED = import.meta.env.VITE_LEAD_IDEMPOTENCY_ENABLED === 'true';

export const AUTHOR = identity.author;

export const absoluteUrl = (path: string) =>
  `${SITE_ORIGIN}${path === '/' ? '/' : path.replace(/\/$/, '')}`;

// Shared published family dates; product-specific claims still need their own sources.
export const ORACLE_FACTS = {
  fmw12cPremierEnds: lifecycle.fmw12c.premierEnds,
  fmw12cExtendedEnds: lifecycle.fmw12c.extendedEnds,
  fmw14cPremierEnds: lifecycle.fmw14c.premierEnds,
  fmw14cExtendedEnds: lifecycle.fmw14c.extendedEnds,
  forms14c: '14.1.2 (February 2025)',
  iam14c: '14.1.2.1 (March 2025)',
  release14c: '14.1.2',
} as const;

export const ORACLE_LIFECYCLE = lifecycle;
